const charGroupMap: Record<string, string> = {
  // Alef variants
  ا: "الف",
  آ: "الف",
  أ: "الف",
  إ: "الف",
  // Ye variants
  ی: "ی",
  ي: "ی",
  ى: "ی",
  ئ: "ی",
  // Kaf variants
  ک: "ک",
  ك: "ک",
  // He variants
  ه: "ه",
  ة: "ه",
};

export function getNameGroupLabel(firstChar: string): string {
  return charGroupMap[firstChar] ?? firstChar.toUpperCase();
}
